import {
  CREATE_PAINEL_INIT,
  CREATE_PAINEL_SUCCESS,
  MODIFY_PAINEL_INIT,
  MODIFY_PAINEL_SUCCESS,
  DELETE_PAINEL_INIT,
  DELETE_PAINEL_SUCCESS,
  LIST_PAINEL_INIT,
  LIST_PAINEL_SUCCESS,
  PAINEIS_ERROR_MSG,
  PAINEIS_CLEAN_UP
} from '../actionTypes';

export const listPainelInit = (data) => ({
  type: LIST_PAINEL_INIT,
  payload: data
});

export const listPainelSuccess = (data) => {
  return {
    type: LIST_PAINEL_SUCCESS,
    payload: data
  };
};

export const createPainelInit = (data) => ({
  type: CREATE_PAINEL_INIT,
  payload: data
});

export const createPainelSuccess = (data) => ({
  type: CREATE_PAINEL_SUCCESS,
  payload: data
});

export const modifyPainelInit = (data) => ({
  type: MODIFY_PAINEL_INIT,
  payload: data
});

export const modifyPainelSuccess = (data) => ({
  type: MODIFY_PAINEL_SUCCESS,
  payload: data
});

export const deletePainelInit = (data) => ({
  type: DELETE_PAINEL_INIT,
  payload: data
});

export const deletePainelSuccess = (data) => ({
  type: DELETE_PAINEL_SUCCESS,
  payload: data
});

export const paineisErrorMsg = (data) => ({
  type: PAINEIS_ERROR_MSG,
  payload: data
});

export const paineisCleanUp = (data) => ({
  type: PAINEIS_CLEAN_UP,
  payload: data
});
